"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PlaceHolder = function PlaceHolder(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? null : _ref$content;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    icon: true,
    style: (0, _Fonts.withWidgetTitleFont)({})
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: icon
  }), title), content && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 30
    }
  }, content));
};

var _default = PlaceHolder;
exports["default"] = _default;